import PropTypes from "prop-types";
import * as React from "react";
import { SSE_NET_HOME } from "../../../constants/externalUrls";
import QuickActionTile from "../templates/quickActionTile";
import SingleLinkTile from "../templates/singleLinkTile";
import { quickActionTilesMap } from "../tilesMap";

const SSENetTile = ({ id }) => {
    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                link={SSE_NET_HOME}
                linkText={quickActionTilesMap[id].description}
                title={"SSENet"}
            />
        </QuickActionTile>
    );
};

SSENetTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default SSENetTile;
